export var ProductCode;
(function (ProductCode) {
    // This is a placeholder.
    // For new features there should be separate Product Codes
    ProductCode["BasicProfessionalSubscription"] = "basic_professional_subscription";
    // Connectors
    ProductCode["ConnectorTqp"] = "connector.tqp";
    ProductCode["ConnectorIcm"] = "connector.icm";
    // Blueprints
    // How To's
    ProductCode["BlueprintFuzzyMatcher"] = "blueprint.fuzzy_matcher";
    ProductCode["BlueprintSmartMatcher"] = "blueprint.smart_matcher";
    ProductCode["BlueprintCombinationMatcher"] = "blueprint.combination_matcher";
    ProductCode["BlueprintHierarchyCreation"] = "blueprint.hierarchy_creation";
    ProductCode["BlueprintHierarchyValidator"] = "blueprint.hierarchy_validator";
    ProductCode["BlueprintForecasting"] = "blueprint.forecasting";
    // ELT
    ProductCode["BlueprintOrderConsolidation"] = "blueprint.order_consolidation";
    ProductCode["BlueprintRosterValidation"] = "blueprint.roster_validation";
    ProductCode["BlueprintRecordIDAndAdjustment"] = "blueprint.recordID_and_adjustment";
    ProductCode["BlueprintIdentifyNewHires"] = "blueprint.identify_new_hires";
    ProductCode["BlueprintTrackTerritoryChanges"] = "blueprint.track_territory_changes";
    ProductCode["BlueprintTransactionReconciliation"] = "blueprint.transaction_reconciliation";
    ProductCode["BlueprintTransactionValidation"] = "blueprint.transaction_validation";
    ProductCode["BlueprintEntityResolution"] = "blueprint.entity_resolution";
    // Sales Compensation
    ProductCode["BlueprintPayoutOutliers"] = "blueprint.payout_outliers";
    ProductCode["BlueprintManualAdjustmentOutliers"] = "blueprint.manual_adjustment_outliers";
    ProductCode["BlueprintSellerValueOutliers"] = "blueprint.seller_valuer_outliers";
    ProductCode["BlueprintASC606Preparation"] = "blueprint.asc_606_preparation";
    ProductCode["BlueprintASC606Amortization"] = "blueprint.asc_606_amortization";
    ProductCode["BlueprintTransactionOutliers"] = "blueprint.transaction_outliers";
    // Revenue Intelligence
    ProductCode["BlueprintOpportunityScores"] = "blueprint.opportunity_scores";
    ProductCode["BlueprintDealValueChanges"] = "blueprint.deal_value_changes";
    ProductCode["BlueprintDiscountingDiagnostics"] = "blueprint.discounting_diagnostics";
    ProductCode["BlueprintLeadScoring"] = "blueprint.lead_scoring";
    ProductCode["BlueprintCustomerLifetimeValue"] = "blueprint.customer_lifetime_value";
    ProductCode["BlueprintSellerCapacity"] = "blueprint.seller_capacity";
    // FA Turnover is for both RevIntel and Sales Compensation
    ProductCode["BlueprintFinancialAdvisorTurnover"] = "blueprint.financial_advisor_turnover";
    // App
    // Marketplace
    ProductCode["AppSalesBenchmarking"] = "app.sales_benchmarking";
    ProductCode["AppGenderPay"] = "app.gender_pay";
    ProductCode["AppDiversity"] = "app.diversity";
    ProductCode["AppCustomerChurn"] = "app.customer_churn";
    ProductCode["AppSellerChurn"] = "app.seller_churn";
    ProductCode["AppSellerPerformance"] = "app.seller_performance";
    // Tools
    // Predictor
    ProductCode["ToolGenderClassifier"] = "tool.gender_classifier";
    ProductCode["ToolSmartMatcher"] = "tool.smart_matcher";
    ProductCode["ToolClassifier"] = "tool.classifier";
    ProductCode["ToolRegressor"] = "tool.regressor";
    ProductCode["ToolForecast"] = "tool.forecast";
    ProductCode["ToolPredictor"] = "tool.predictor";
    // Group
    ProductCode["ToolAggregate"] = "tool.aggregate";
    ProductCode["ToolAggregateV2"] = "tool.aggregate_v2";
    ProductCode["ToolBinning"] = "tool.binning";
    ProductCode["ToolPercentile"] = "tool.percentile";
    // Compare
    ProductCode["ToolRank"] = "tool.rank";
    ProductCode["ToolSort"] = "tool.sort";
    // Clean
    ProductCode["ToolAdapt"] = "tool.adapt";
    ProductCode["ToolCase"] = "tool.case";
    ProductCode["ToolChangeType"] = "tool.change_type";
    ProductCode["ToolConditional"] = "tool.conditional";
    ProductCode["ToolUnique"] = "tool.unique";
    ProductCode["ToolDrop"] = "tool.drop";
    ProductCode["ToolFill"] = "tool.fill";
    ProductCode["ToolFilter"] = "tool.filter";
    ProductCode["ToolLimit"] = "tool.limit";
    ProductCode["ToolRemoveOutliers"] = "tool.remove_outliers";
    ProductCode["ToolRemoveEmpty"] = "tool.remove_empty";
    ProductCode["ToolRename"] = "tool.rename";
    ProductCode["ToolReorder"] = "tool.reorder";
    ProductCode["ToolSelect"] = "tool.select";
    ProductCode["ToolHierarchyValidator"] = "tool.hierarchy_validator";
    ProductCode["ToolHierarchyValidatorV2"] = "tool.hierarchy_validator_v2";
    ProductCode["ToolCleanCharacter"] = "tool.clean_character";
    ProductCode["ToolSplitColumns"] = "tool.split_columns";
    // Visualizations
    ProductCode["ToolTable"] = "tool.table";
    ProductCode["ToolHistogram"] = "tool.histogram";
    ProductCode["ToolLine"] = "tool.line";
    ProductCode["ToolSmoothLine"] = "tool.smooth_line";
    ProductCode["ToolStepLine"] = "tool.step_line";
    ProductCode["ToolAreaLine"] = "tool.area_line";
    ProductCode["ToolAreaSmoothLine"] = "tool.area_smooth_line";
    ProductCode["ToolAreaStepLine"] = "tool.area_step_line";
    ProductCode["ToolStackedAreaLine"] = "tool.stacked_area_line";
    ProductCode["ToolStackedAreaSmoothLine"] = "tool.stacked_area_smooth_line";
    ProductCode["ToolStackedAreaStepLine"] = "tool.stacked_area_step_line";
    ProductCode["ToolCombo"] = "tool.combo";
    ProductCode["ToolColumn"] = "tool.column";
    ProductCode["ToolStackedColumn"] = "tool.stacked_column";
    ProductCode["ToolBar"] = "tool.bar";
    ProductCode["ToolStackedBar"] = "tool.stacked_bar";
    ProductCode["ToolPie"] = "tool.pie";
    ProductCode["ToolDoughnut"] = "tool.doughnut";
    ProductCode["ToolScatter"] = "tool.scatter";
    ProductCode["ToolBubble"] = "tool.bubble";
    ProductCode["ToolBubbleSingleAxis"] = "tool.bubble_single_axis";
    ProductCode["ToolMap"] = "tool.map";
    ProductCode["ToolScatterMap"] = "tool.scatter_map";
    ProductCode["ToolWaterfall"] = "tool.waterfall";
    ProductCode["ToolRadar"] = "tool.radar";
    ProductCode["ToolCandlestick"] = "tool.candlestick";
    ProductCode["ToolForecasting"] = "tool.forecasting";
    ProductCode["ToolSankey"] = "tool.sankey";
    ProductCode["ToolHeatmap"] = "tool.heatmap";
    ProductCode["ToolBoxplot"] = "tool.boxplot";
    ProductCode["ToolNestedPie"] = "tool.nested_pie";
    // Date tools
    ProductCode["ToolDateAdd"] = "tool.date_add";
    ProductCode["ToolDateDiff"] = "tool.date_diff";
    ProductCode["ToolDatePart"] = "tool.date_part";
    ProductCode["ToolDateAggregate"] = "tool.date_aggregate";
    ProductCode["ToolDateFormat"] = "tool.date_format";
    // Compute tools
    ProductCode["ToolAmortization"] = "tool.amortization";
    ProductCode["ToolConfusionMatrix"] = "tool.confusion_matrix";
    ProductCode["ToolMultiFormula"] = "tool.multi_formula";
    ProductCode["ToolLag"] = "tool.lag";
    ProductCode["ToolMinMaxScaler"] = "tool.min_max_scaler";
    ProductCode["ToolMostCommon"] = "tool.most_common";
    ProductCode["ToolOversample"] = "tool.oversample";
    ProductCode["ToolRunningAverage"] = "tool.running_average";
    ProductCode["ToolRunningTotal"] = "tool.running_total";
    ProductCode["ToolSample"] = "tool.sample";
    ProductCode["ToolStandardScaler"] = "tool.standard_scaler";
    ProductCode["ToolUndersample"] = "tool.undersample";
    ProductCode["ToolWeightedAverage"] = "tool.weighted_average";
    // Encode
    ProductCode["ToolCategoryEncoder"] = "tool.category_encoder";
    ProductCode["ToolOneHotEncoder"] = "tool.one_hot_encoder";
    // Text tools
    ProductCode["ToolChangeCase"] = "tool.change_case";
    ProductCode["ToolExtract"] = "tool.extract";
    ProductCode["ToolMergeColumns"] = "tool.merge_columns";
    ProductCode["ToolReplace"] = "tool.replace";
    ProductCode["ToolMultiReplace"] = "tool.multi_replace";
    ProductCode["ToolSelectWord"] = "tool.select_word";
    ProductCode["ToolTextBetween"] = "tool.text_between";
    ProductCode["ToolTextLength"] = "tool.text_length";
    ProductCode["ToolTextPart"] = "tool.text_part";
    ProductCode["ToolTextSentiment"] = "tool.text_sentiment";
    ProductCode["ToolTrim"] = "tool.trim";
    ProductCode["ToolTrimTags"] = "tool.trim_tags";
    ProductCode["ToolTextClassifier"] = "tool.text_classifiers";
    ProductCode["ToolWordFrequency"] = "tool.word_frequency";
    // Prepare tools
    ProductCode["ToolCombinationMatcher"] = "tool.combination_matcher";
    ProductCode["ToolFuzzyMatcher"] = "tool.fuzzy_matcher";
    ProductCode["ToolJoin"] = "tool.join";
    ProductCode["ToolJoinV2"] = "tool.join_v2";
    ProductCode["ToolRecordID"] = "tool.record_id";
    ProductCode["ToolRepeat"] = "tool.repeat";
    ProductCode["ToolReshape"] = "tool.reshape";
    ProductCode["ToolReshapeV2"] = "tool.reshape_v2";
    ProductCode["ToolSnapshot"] = "tool.snapshot";
    ProductCode["ToolSplit"] = "tool.split";
    ProductCode["ToolTextGradeLevel"] = "tool.text_grade_level";
    ProductCode["ToolUnion"] = "tool.union";
    ProductCode["ToolMultiUnion"] = "tool.multi_union";
    ProductCode["ToolHierarchy"] = "tool.hierarchy";
    ProductCode["ToolHierarchyV2"] = "tool.hierarchy_v2";
    ProductCode["ToolLookup"] = "tool.lookup";
    // Understand
    ProductCode["ToolSegmentation"] = "tool.segmentation";
    ProductCode["ToolOutlier"] = "tool.outlier";
    // Connect
    ProductCode["ToolData"] = "tool.data";
    ProductCode["ToolPipe"] = "tool.pipe";
    ProductCode["ToolMultiPortPipe"] = "tool.multi_port_pipe";
    ProductCode["ToolExport"] = "tool.export";
    ProductCode["ToolUSIncome"] = "tool.us_income";
    ProductCode["ToolUSPopulation"] = "tool.us_population";
    // Optimization
    ProductCode["ToolAssignmentOptimization"] = "tool.assignment_optimization";
    // Monte Carlo Simulation
    ProductCode["ToolMonteCarlo"] = "tool.monte_carlo";
    ProductCode["ToolRandomNumberGenerator"] = "tool.random_number_generator";
    // Sample data
    ProductCode["ToolSampleCustomers"] = "tool.sample_customers";
    // SPM Tools
    ProductCode["ToolPeriodMapper"] = "tool.period_mapper";
    ProductCode["ToolRuleMapper"] = "tool.rule_mapper";
    ProductCode["ToolRuleMapperV2"] = "tool.rule_mapper_v2";
    // Incentives Tools
    ProductCode["ToolIncentivesExport"] = "tool.incentives_export";
    ProductCode["ToolIncentivesImport"] = "tool.incentives_import";
    ProductCode["ToolIncentivesTable"] = "tool.incentives_table";
    ProductCode["ToolIncentivesPeriod"] = "tool.incentives_period";
    // Incentives Calc Type Tools
    ProductCode["ToolUserDefinedCalc"] = "tool.user_defined_calc";
    ProductCode["ToolSortCalc"] = "tool.sort_calc";
    ProductCode["ToolTimeShiftCalc"] = "tool.time_shift_calc";
    ProductCode["ToolCategoryCalc"] = "tool.category_calc";
    ProductCode["ToolTrueUp"] = "tool.true_up";
    ProductCode["ToolPeriodAdd"] = "tool.period_add";
    ProductCode["ToolPeriodDiff"] = "tool.period_diff";
    ProductCode["ToolExpandPicklist"] = "tool.expand_picklist";
    ProductCode["ToolPeriodAccumulation"] = "tool.period_accumulation";
    // Reusable Logic
    ProductCode["ToolReusableLogic"] = "tool.reusable_logic";
    ProductCode["ToolReusableLogicInput"] = "tool.reusable_logic_input";
    ProductCode["ToolReusableLogicOutput"] = "tool.reusable_logic_output";
})(ProductCode || (ProductCode = {}));
//# sourceMappingURL=productCode.js.map